import type { Catharsis, CatharsisArgs, CompNodes } from '@wix/thunderbolt-catharsis'
import { getCatharsis } from '@wix/thunderbolt-catharsis'
import { multi, optional, withDependencies } from '@wix/thunderbolt-ioc'
import {
	appConstant,
	CatharsisStructureStoreSymbol,
	CompNodeProviderSymbol,
	DataNodeProviderSymbol,
	MaterializerFactorySymbol,
	OnInvalidationSymbol,
} from './symbols'

export const CatharsisFactory = withDependencies(
	[
		multi(OnInvalidationSymbol),
		multi(CompNodeProviderSymbol),
		multi(DataNodeProviderSymbol),
		MaterializerFactorySymbol,
		optional(CatharsisStructureStoreSymbol),
		appConstant('schemas'),
	] as const,
	(
		onInvalidations,
		compNodesProviders,
		dataNodesProviders,
		materializerFactory,
		structureStore,
		schemas,
	): Catharsis => {
		const componentNodes = compNodesProviders.reduce((acc, feature) => {
			Object.assign(acc, feature.getCompNodes())
			return acc
		}, {} as CompNodes<any>)

		const dataNodes = dataNodesProviders.reduce((acc, nodes) => Object.assign(acc, nodes), {})
		const catharsisArgs: CatharsisArgs = {
			extensions: {
				componentNodes,
				dataNodes,
				schemas,
			},
			structureStore,
			onInvalidation(path: Array<string>, get: <T = any>(path: string | Array<string | number>) => T): void {
				onInvalidations.forEach((onInvalidation) => onInvalidation(path, get))
			},
			materializerFactory,
		}

		return getCatharsis(catharsisArgs)
	}
)
